'use client'

import { IconSearch } from '@macarongfactory/web-icons'
import { SearchField } from '@macarongfactory/web-ui'
import Link from 'next/link'

import { MycleLogoDefault } from '@/shared/assets/icons'

import { RANK_TRACK_CODE, useRankTrackingContext } from '../_features/rank'

/**
 * 랭킹 페이지 상단 검색 헤더 (sticky) — Figma `검색 필드`
 * - 모바일: 로고(100×20) + 검색 아이콘 → 차종 검색
 * - 데스크탑: 로고 + 검색 필드('제조사/모델 검색')
 */
const RankHeader = () => {
  const track = useRankTrackingContext()

  return (
    <header className='sticky top-0 z-20 bg-background-surface-default'>
      <div className='flex w-full items-center gap-dimension-x2 px-dimension-x5 py-dimension-x3 lg:gap-dimension-x6'>
        <Link
          href='/modoocar/home'
          aria-label='모두의 차고 홈'
          className='shrink-0 text-foreground-brand-strong'
          onClick={() => track.logoClick()}
        >
          <MycleLogoDefault fill='currentColor' width='100' height='20' />
        </Link>

        <Link
          href='/modoocar/search'
          aria-label='제조사/모델 검색'
          className='hidden flex-1 lg:block'
          onClick={() =>
            track.itemClick(RANK_TRACK_CODE.HEADER, 'search_icon', '검색 클릭')
          }
        >
          {/* 클릭이 Link로 전달되도록 입력 필드는 포커스/타이핑을 막고 표시 전용으로 둔다 */}
          <SearchField
            placeholder='제조사/모델 검색'
            className='pointer-events-none w-full'
          />
        </Link>

        <Link
          href='/modoocar/search'
          aria-label='차종 검색'
          className='ml-auto shrink-0 lg:hidden'
          onClick={() =>
            track.itemClick(RANK_TRACK_CODE.HEADER, 'search_icon', '검색 클릭')
          }
        >
          <IconSearch width={24} height={24} />
        </Link>
      </div>
    </header>
  )
}

export default RankHeader
